import { automationRuleDependencies } from 'modules/automation-rules/constants/automation-rule-dependencies'
import { AutomationRuleApiInterface } from 'modules/automation-rules/types/automation-rule-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export const useStoreOptinRules = (optinId: number) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AutomationRuleApiInterface>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(
    [
      `/api/dashboard/customer/digital-store/item-optin/${optinId}/automation-rules`,
      ...automationRuleDependencies,
    ],
    fetcher,
    {},
    !!user,
  )
}
